import LRU from "lru-cache";

const imageCache = new LRU({
    // A reasonable amount of images to cover all UI elements + a single story.
    max: 150,
});

export default imageCache;
